<div class="dialog">
  <mat-dialog-content>
    <div *ngIf="!data.user.isLocked" class="header"><h2>Lock Account</h2></div>
    <div *ngIf="data.user.isLocked" class="header"><h2>Unlock Account</h2></div>
    <div *ngIf="!actionPerformed">
      <div *ngIf="!data.user.isLocked" class="content">
        <p>Are you sure you would like to lock the account for
          <b>{{ data.user.memberName }}, {{ data.user.username }}</b>?</p>
      </div>
      <div *ngIf="data.user.isLocked" class="content">
        <p>Are you sure you would like to unlock the account for
          <b>{{ data.user.memberName }}, {{ data.user.username }}</b>?</p>
      </div>
    </div>
    <div *ngIf="actionPerformed">
      <div *ngIf="!data.user.isLocked" class="content">
        <p>We have locked the account for
          <b>{{ data.user.memberName }}, {{ data.user.username }}</b></p>
      </div>
      <div *ngIf="data.user.isLocked" class="content">
        <p>We have unlocked the account for
          <b>{{ data.user.memberName }}, {{ data.user.username }}</b></p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions *ngIf="!actionPerformed" class="justify-space-between">
    <button
      mat-stroked-button
      color="primary"
      *ngIf="!actionPerformed"
      class="blue-outline-button"
      (click)="onNoClick()"
    >
      CANCEL
    </button>
    <button
      *ngIf="!data.user.isLocked"
      mat-flat-button
      color="primary"
      (click)="toggleLock(data.user.idNumber)"
    >
    YES, LOCK ACCOUNT
    </button>
    <button
      *ngIf="data.user.isLocked"
      mat-flat-button
      color="primary"
      (click)="toggleLock(data.user.idNumber)"
    >
      YES, UNLOCK ACCOUNT
    </button>
  </mat-dialog-actions>
  <mat-dialog-actions align="center" *ngIf="actionPerformed">
      <button
      mat-flat-button
      color="primary"
      class="blue-outline-button"
      (click)="onNoClick()"
    >
      CLOSE
    </button>
  </mat-dialog-actions>
</div>
